/* eslint-disable quote-props */
/* eslint-disable max-len */
import _ from 'lodash';
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { questionSlotData } from '../../../models/FormSpecRegistry';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_028: Question = {
  id: 'pres-028-part-milieux-hydriques',
  oldId: '42',
  title: 'Part des milieux hydriques',
  number: '3.12',
  description: ['Par rapport à la superfie totale du territoire'],
  type: QuestionType.INDICATOR,
  frequency: 3,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[], values: any) => data,
      autofill: (values: any, sectionPath: string) => {
        const v1 = parseFloat(_.get(values, questionSlotData(sectionPath, 'pres-027-superficie-milieux-hydriques'))) || 0;
        const superficie = parseFloat(_.get(values, 'superficie')) || 1;
        return ((v1 / 100 / superficie) * 100).toFixed(2);
      },
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.PERCENTAGE,
    },
  ],
};

export const question_pres_028_v2: Question = question_pres_028;
export const question_pres_028_v3: Question = question_pres_028;
